<template>
  <div class="container">
    <div class="row">
      <div class="col-xs-6">
        <HelpText>
          <h3>
            Edit Ad Format
          </h3>

          <p>
            Enter the details of the ad format.
          </p>
        </HelpText>
      </div>

      <div class="col-xs-18">
        <div class="panel panel-default">
          <div class="panel-body">
            <LoadingSpinner v-if="loading"/>

            <form v-else @submit.prevent="submit" class="form-horizontal">
              <TextFormGroup
                  v-model="data.name"
                  name="name"
                  label="Name"
                  :error="getError('name')"
              />

              <TextareaFormGroup
                  v-model="data.description"
                  name="description"
                  label="Marketing Site Description"
                  :error="getError('description')"
              />

              <CkEditorFormGroup
                  v-model="data.partner_description"
                  name="partner_description"
                  label="Partner CMS Description"
                  :error="getError('partner_description')"
              />

              <TextFormGroup
                  v-model="data.location"
                  name="location"
                  label="Location"
                  :error="getError('location')"
              />

              <NumberFormGroup
                  v-model="data.price_per_day"
                  name="price_per_day"
                  label="Price Per Day"
                  help-text="The price per day of the ad format."
                  :error="getError('price_per_day')"
              />

              <RadioFormGroup
                  v-model="data.send_content_reminders"
                  name="send_content_reminders"
                  label="Send Content Reminders"
                  help-text="Send content reminders for this ad format."
                  :options="[{value: true, label: 'Yes'}, {value: false, label: 'No'}]"
                  :error="getError('send_content_reminders')"
              />

              <RadioFormGroup
                  v-model="data.is_advertised"
                  name="is_advertised"
                  label="Is Advertised"
                  help-text="Advertise the ad format on the marketing site."
                  :options="[{value: true, label: 'Yes'}, {value: false, label: 'No'}]"
                  :error="getError('is_advertised')"
              />

              <SelectFormGroup
                  v-model="data.time_based_subchannel_id"
                  name="time_based_subchannel_id"
                  label="Subchannel"
                  help-text="Change the subchannel that the ad format belongs to."
                  :options="timeBasedSubchannelOptions"
                  :error="getError('time_based_subchannel_id')"
              />

              <TechnicalDescriptionsFormGroup
                  v-model="data.technical_descriptions"
                  :errors="errors"
              />

              <GalleryFormGroup
                  v-model="data.image_id"
                  name="image_id"
                  label="Image"
                  :error="getError('image_id')"
                  :nullable="true"
              />

              <GalleryFormGroup
                  v-model="data.example_image_id"
                  name="example_image_id"
                  label="Example Image"
                  :error="getError('example_image_id')"
                  :nullable="true"
              />

              <hr>

              <SubmitFormGroup button-class="btn-black"/>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import CkEditorFormGroup from '@/vendor/forms/FormGroups/Horizontal/CkEditor'
import Errors from '@/mixins/Errors'
import GalleryFormGroup from '@/components/FormGroups/Horizontal/Gallery'
import HelpText from '@/components/HelpText'
import Load from '@/mixins/Load'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import NumberFormGroup from '@/vendor/forms/FormGroups/Horizontal/Number'
import RadioFormGroup from '@/vendor/forms/FormGroups/Horizontal/Radio'
import SelectFormGroup from '@/vendor/forms/FormGroups/Horizontal/Select'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'
import TechnicalDescriptionsFormGroup from '@/components/FormGroups/Horizontal/TechnicalDescriptions'
import TextareaFormGroup from '@/vendor/forms/FormGroups/Horizontal/Textarea'
import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

export default {
  components: {
    CkEditorFormGroup,
    GalleryFormGroup,
    HelpText,
    LoadingSpinner,
    NumberFormGroup,
    RadioFormGroup,
    SelectFormGroup,
    SubmitFormGroup,
    TechnicalDescriptionsFormGroup,
    TextareaFormGroup,
    TextFormGroup
  },

  mixins: [Errors, Load],

  model: {
    prop: 'portal',
    event: 'portal-updated'
  },

  props: ['portal', 'timeBasedChannelId', 'adFormatId'],

  data() {
    return {
      data: null,

      timeBasedSubchannels: null,

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    timeBasedSubchannelOptions() {
      return this.timeBasedSubchannels.map(timeBasedSubchannel => {
        return {
          value: timeBasedSubchannel.id,
          label: timeBasedSubchannel.attributes.name,
        }
      })
    }
  },

  methods: {
    load() {
      Promise.all([
        http.get('/api/v2/time-based-ad-formats/' + this.adFormatId),
        http.get('/api/v2/time-based-subchannels', {'filter[time_based_channel_id]': this.timeBasedChannelId}),
      ]).then(responses => {
        this.data = responses[0].data.data.attributes

        this.timeBasedSubchannels = responses[1].data.data

        this.loading = false
      })
    },

    submit() {
      http.put('/api/v2/time-based-ad-formats/' + this.adFormatId, this.data)
          .then(response => {
            notify.success('The ad format was saved')

            this.$router.push('/portals/' + this.portal.id + '/time-based-channels/' + this.timeBasedChannelId + '/time-based-subchannels/' + response.data.data.attributes.time_based_subchannel_id)
          })
          .catch(this.catchValidationErrors)
    }
  }
}
</script>
